import {Component, Input, OnChanges, OnInit} from '@angular/core';

import {BlockingError, ErrorMessage} from '../../form-generator.interfaces';

interface TranslateKeys {
  title: string;
  text: string;
  correct: string;
}

@Component({
  selector: 'gp-blocking-error-modal',
  templateUrl: './blocking-error-modal.component.html',
  styleUrls: ['./blocking-error-modal.component.scss']
})
export class BlockingErrorModalComponent implements OnInit, OnChanges {

  @Input()
  blockingErrors: BlockingError[] = [];

  public translateKeys = new Map<string, TranslateKeys>([
    [
      'single', {
      title: 'FORM_GENERATOR.BLOCKING_ERROR.title',
      text: 'FORM_GENERATOR.BLOCKING_ERROR.text',
      correct: 'FORM_GENERATOR.BLOCKING_ERROR.correct'
    }
    ],
    [
      'plurals', {
      title: 'FORM_GENERATOR.BLOCKING_ERRORS.title',
      text: 'FORM_GENERATOR.BLOCKING_ERRORS.text',
      correct: 'FORM_GENERATOR.BLOCKING_ERRORS.correct'
    }
    ]
  ]);

  public selectedTranslateKey: TranslateKeys = this.translateKeys.get('single');

  // Map<TabName, Map<GroupZoneName, ErrorMessages[]>
  public sortedBlockingErrors: Map<string, Map<string, ErrorMessage[]>> = new Map();

  ngOnInit() {
    this.selectTranslateKeys();
    this.sortBlockingErrors();
  }

  public ngOnChanges(changes: any) {
    if (changes.blockingErrors) {
      this.selectTranslateKeys();
      this.sortBlockingErrors();
    }
  }

  private selectTranslateKeys() {
    const key: string = this.blockingErrors.length > 1 ? 'plurals' : 'single';
    this.selectedTranslateKey = this.translateKeys.get(key);
  }

  private sortBlockingErrors() {
    this.sortedBlockingErrors.clear();
    this.blockingErrors.forEach((blockingError: BlockingError) => {
      if (!this.sortedBlockingErrors.has(blockingError.tabSheetTransId)) {
        this.sortedBlockingErrors.set(blockingError.tabSheetTransId, new Map());
      }
      const currentTab = this.sortedBlockingErrors.get(blockingError.tabSheetTransId);
      if (!currentTab.has(blockingError.groupZoneTransId)) {
        currentTab.set(blockingError.groupZoneTransId, []);
      }
      let errorMessage: ErrorMessage;
      if (blockingError.errorMessage.zone) {
        errorMessage = {
          ...blockingError.errorMessage,
          zone: blockingError.errorMessage.zone.replace('§', '.'),
          // take the error key without the zone prefix we added (see pushZoneError in form-card and form-table)
          text: blockingError.errorMessage.text.split('/').pop()
        };
      } else {
        errorMessage = blockingError.errorMessage;
      }

      currentTab.get(blockingError.groupZoneTransId).push(errorMessage);
    });
  }
}
